export default [
  [
    [4, 5],
    [1, 2],
    [6, 3],
    [10, 7],
    [11, 8],
    [12, 9],
    [16, 13],
    [17, 14],
    [18, 15],
  ],
  [
    [22, 19],
    [23, 20],
    [24, 21],
    [28, 25],
    [29, 26],
    [30, 27],
    [34, 31],
    [32, 33],
    [36, 35],
  ],
  [
    [5, 6],
    [4, 3],
    [2, 1],
    [12, 8],
    [10, 9],
    [11, 7],
    [18, 14],
    [16, 15],
    [17, 13],
  ],
  [
    [24, 20],
    [22, 21],
    [23, 19],
    [30, 26],
    [28, 27],
    [29, 25],
    [31, 32],
    [34, 33],
    [35, 36],
  ],
  [
    [5, 3],
    [6, 4],
    [1, 2],
    [11, 9],
    [12, 7],
    [10, 8],
    [17, 15],
    [18, 13],
    [16, 14],
  ],
  [
    [23, 21],
    [24, 19],
    [22, 20],
    [29, 27],
    [30, 25],
    [28, 26],
    [31, 33],
    [36, 35],
    [34, 32],
  ],

  [
    [16, 4],
    [17, 5],
    [18, 6],
    [10, 11],
    [1, 2],
    [12, 3],
    [13, 7],
    [14, 8],
    [15, 9],
  ],
  [
    [34, 22],
    [24, 23],
    [36, 35],
    [28, 19],
    [29, 20],
    [30, 21],
    [31, 25],
    [32, 26],
    [33, 27],
  ],
  [
    [18, 5],
    [16, 6],
    [17, 4],
    [11, 12],
    [10, 3],
    [2, 1],
    [15, 8],
    [13, 9],
    [14, 7],
  ],
  [
    [23, 22],
    [34, 24],
    [35, 36],
    [30, 20],
    [28, 21],
    [29, 19],
    [33, 26],
    [31, 27],
    [32, 25],
  ],
  [
    [17, 6],
    [18, 4],
    [16, 5],
    [11, 3],
    [12, 10],
    [1, 2],
    [14, 9],
    [15, 7],
    [13, 8],
  ],
  [
    [24, 22],
    [36, 35],
    [34, 23],
    [29, 21],
    [30, 19],
    [28, 20],
    [32, 27],
    [33, 25],
    [31, 26],
  ],

  [
    [13, 10],
    [14, 11],
    [15, 12],
    [7, 4],
    [8, 5],
    [9, 6],
    [17, 16],
    [2, 1],
    [3, 18],
  ],
  [
    [31, 28],
    [32, 29],
    [33, 30],
    [25, 22],
    [26, 23],
    [27, 24],
    [19, 34],
    [20, 21],
    [35, 36],
  ],
  [
    [15, 11],
    [13, 12],
    [14, 10],
    [9, 5],
    [7, 6],
    [8, 4],
    [3, 17],
    [16, 18],
    [2, 1],
  ],
  [
    [33, 29],
    [31, 30],
    [32, 28],
    [27, 23],
    [25, 24],
    [26, 22],
    [21, 19],
    [35, 36],
    [20, 34],
  ],
  [
    [14, 12],
    [15, 10],
    [13, 11],
    [8, 6],
    [9, 4],
    [7, 5],
    [17, 18],
    [3, 16],
    [1, 2],
  ],
  [
    [32, 30],
    [33, 28],
    [31, 29],
    [26, 24],
    [27, 22],
    [25, 23],
    [19, 20],
    [21, 34],
    [36, 35],
  ],

  [
    [7, 16],
    [8, 17],
    [9, 18],
    [14, 13],
    [2, 1],
    [3, 15],
    [4, 10],
    [5, 11],
    [6, 12],
  ],
  [
    [25, 34],
    [26, 27],
    [35, 36],
    [19, 31],
    [20, 32],
    [21, 33],
    [22, 28],
    [23, 29],
    [24, 30],
  ],
  [
    [9, 17],
    [7, 18],
    [8, 16],
    [3, 14],
    [13, 15],
    [2, 1],
    [6, 11],
    [4, 12],
    [5, 10],
  ],
  [
    [27, 25],
    [35, 36],
    [26, 34],
    [21, 32],
    [19, 33],
    [20, 31],
    [24, 29],
    [22, 30],
    [23, 28],
  ],
  [
    [8, 18],
    [9, 16],
    [7, 17],
    [15, 14],
    [3, 13],
    [1, 2],
    [5, 12],
    [6, 10],
    [4, 11],
  ],
  [
    [35, 36],
    [27, 34],
    [25, 26],
    [20, 33],
    [21, 31],
    [19, 32],
    [23, 30],
    [24, 28],
    [22, 29],
  ],
];
